<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <!-- <vs-th></vs-th> -->
        <vs-th
          v-for="(head, index) in this.table.heads"
          :key="index"
          :sort-key="head.field"
          >{{ head.title }}</vs-th
        >
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <!-- <vs-td> </vs-td> -->
          <vs-td
            v-for="(head, index) in table.heads"
            :key="index"
            :data="data[indextr][head.field]"
            ><a
              target="_blank"
              v-if="
                head.field == 'file_path' && data[indextr]['file_path'] != ''
              "
              :href="data[indextr]['file_path']"
              >{{ data[indextr]["file_name"] }}</a
            >
            <span
              v-else-if="
                head.field == 'file_path' && data[indextr]['file_path'] == ''
              "
              >{{ data[indextr]["file_name"] }}</span
            >
            <span v-else-if="head.field == 'created_at'">{{
              dateFormat(data[indextr][head.field])
            }}</span>
            <span v-else>{{ data[indextr][head.field] }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    warehouseID: Number,
    warehouseCode: String,
    dateStart: String,
    dateEnd: String,
    type: Object,
    warehouseIDAll: Array,
    whIDs: Array,
    warehouseCodeAll: String,
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        heads: [
          {
            field: "created_at",
            title: "Created At",
          },
          {
            field: "created_by",
            title: "Created By",
          },
          {
            field: "file_path",
            title: "File",
          },
          {
            field: "status",
            title: "Status",
          },
        ],
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      if (page == this.table.page) {
        return;
      }
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    dateFormatParam(date) {
      if (date) {
        return moment(String(date)).utcOffset(0).format("YYYY-MM-DD");
      }
    },
    handleExport(file) {
      const fileTitle =
        this.type && this.type.value === "shipment-plan-lines"
          ? "shipmentPlanLines" +
            "_" +
            this.warehouseCodeAll +
            "_" +
            this.dateFormatParam(this.dateStart) +
            "_-_" +
            this.dateFormatParam(this.dateEnd)
          : "shipmentPlan" +
            "_" +
            this.warehouseCodeAll +
            "_" +
            this.dateFormatParam(this.dateStart) +
            "_-_" +
            this.dateFormatParam(this.dateEnd);
      const endpoint =
        this.type && this.type.value === "shipment-plan-lines"
          ? "/api/v1/report/shipment-planning-line-exportv2"
          : "/api/v1/report/shipment-planning-exportv2";
      this.$http
        .get(endpoint, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            warehouse_id: this.warehouseID,
            date_from: this.dateFormatParam(this.dateStart),
            date_to: this.dateFormatParam(this.dateEnd),
            file: file,
            Title: fileTitle,
            warehouse_ids: this.warehouseIDAll.join(","),
            warehouses_code: this.warehouseCodeAll,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.notify({
              title: "Success",
              text: "Export process running in background, please refresh this tab shortly",
              color: "success",
              position: "top-right",
            });
            this.getData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.data ? resp.data.message : "Export failed",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/report/shipment-plan-export/table", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            warehouse_id: this.warehouseID,
            warehouse_ids: this.whIDs.join(","),
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(val) {
      //return moment(val).local();
      return moment(val).add(-7, "h").utc().local();
    },
  },
  watch: {
    detail() {},
    startDate() {},
    endDate() {},
    whIDs(val) {
      if (val !== null && val !== undefined) {
        this.getData();
      }
    },
  },
  mounted() {},

  computed: {
    setPage: {
      get() {
        return this.table.page;
      },
      set(val) {
        if (val != this.table.page) {
          this.handleChangePage(val);
        }
      },
    },
  },
};
</script>
